//
//
//
//
//
//
//
//

import {
  mapMutations,
  mapActions,
  mapState
} from 'vuex';
import AppHearder from './components/head.vue'
import AppFooter from './components/footer.vue'
import CategryMenu from "./components/menu.vue";
import {
  IS_LOGIN,
  USER_TOKEN
} from "./vuex/types";
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  watch: {
      '$route' (to, from) {
        // 对路由变化作出响应...
        // this.routerParms.list=to.query.list
        this.reload()
      },
  },
  components: {
    AppHearder,
    AppFooter,
    'categry-menu': CategryMenu
  },
  created: async function() {
    await this.appInit();
    await this.apparticlelist();

    var _53code = document.createElement("script");_53code.src = "https://tb.53kf.com/code/code/5a339fc85d2c436d3b65b4d575c4a1401/1";var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(_53code, s);
  },

  methods: {
    //应用初始化,获取模板数据，自动同步新页面到后台,获取用户信息
    ...mapActions(['appInit','apparticlelist']),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    message(val){
      this.$refs.hearder.message = val;
    }
  },
  mounted() {
  }
}



// WEBPACK FOOTER //
// ./src/App.vue